export default "<ion-app [ngClass]=\"{'dark': theme === 'dark'}\">\n  <ion-router-outlet></ion-router-outlet>\n  <app-loader></app-loader>\n</ion-app>";